'use client';

import { useSearchParams } from 'next/navigation';
import { RedeemDiscount } from 'components/ui/organisms/redeem-discount/index';

export const RedeemDiscountTastic = () => {
  const searchParams = useSearchParams();
  const discountCode = searchParams.get('code') ?? '';

  return <RedeemDiscount discountCode={discountCode} />;
};
